import BlockReplacement from './base/block-replacement';
export default BlockReplacement.extend().reopenClass({
  replacement: {
    pattern: /(?:[\s\S])?^```([\s\S]*)?(?:```)?/m,
    replaceWith: 'Code',
    captureGroupMapping: ['text']
  }
});